import { Label } from "@osago/ui";
import { PRODUCTS, type ProductKey } from "@/shared/config/widget";

interface ProductFieldProps {
  value: ProductKey;
  onChange: (value: ProductKey) => void;
}

export function ProductField({ value, onChange }: ProductFieldProps) {
  return (
    <div className="flex flex-col gap-2.5">
      {PRODUCTS.map((product) => (
        <label key={product.key} className="flex cursor-pointer items-start gap-2">
          <input
            type="radio"
            name="widget-product"
            value={product.key}
            checked={product.key === value}
            onChange={() => onChange(product.key)}
            className="sr-only"
          />
          <span className="product-radio" />
          <span className="flex flex-col">
            <Label variant="body" as="span">
              {product.label}
            </Label>
            <Label variant="hint" as="span">
              {product.hint}
            </Label>
          </span>
        </label>
      ))}
    </div>
  );
}
